import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { BookOpen, ArrowRight, Clock, Search } from "lucide-react";
import { GUIDES } from "@/data/guides";
import Seo from "@/components/Seo";

export default function Guides() {
  const [q, setQ] = useState("");
  const query = q.trim().toLowerCase();
  const filtered = query
    ? GUIDES.filter((g) => `${g.title} ${g.excerpt}`.toLowerCase().includes(query))
    : GUIDES;

  return (
    <div className="max-w-6xl mx-auto px-4 py-14" data-testid="guides-page">
      <Seo
        title="Heating Guides & Advice"
        description="Free heating guides from HHCV — how TRVs and motorised valves work, replacing a thermostat, fixing a cold radiator and more. Expert advice from UK heating specialists."
      />
      <div className="max-w-2xl">
        <span className="text-overline text-primary">Guides &amp; advice</span>
        <h1 className="mt-2 text-3xl sm:text-4xl font-display font-black tracking-tight">Heating Guides &amp; Buying Advice</h1>
        <p className="mt-4 text-muted-foreground leading-relaxed">
          Practical, jargon-free guides from our heating specialists — with over 80 years' combined experience across our team. Learn how the key parts of your central heating work and how to choose the right replacement.
        </p>
      </div>

      <div className="mt-8 max-w-md relative">
        <input
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search guides… (e.g. TRV, thermostat, cold radiator)"
          data-testid="guides-search-input"
          className="w-full h-11 pl-10 pr-3 bg-white border border-border rounded-sm text-sm focus:outline-none focus:ring-2 focus:ring-primary/40 focus:border-primary"
        />
        <Search className="w-4 h-4 absolute left-3.5 top-1/2 -translate-y-1/2 text-muted-foreground" />
      </div>

      {filtered.length === 0 ? (
        <p className="mt-10 text-muted-foreground" data-testid="guides-no-results">
          No guides match "{q}". Try a different search, or <Link to="/contact" className="text-primary underline-offset-2 hover:underline">ask our team</Link>.
        </p>
      ) : (
        <div className="mt-8 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {filtered.map((g) => (
            <Link
              key={g.slug}
              to={`/guides/${g.slug}`}
              data-testid={`guide-card-${g.slug}`}
              className="group flex flex-col border border-border rounded-sm bg-card p-6 hover:border-primary hover:shadow-hard transition-all">
              <BookOpen className="w-7 h-7 text-primary" />
              <h2 className="mt-4 text-lg font-display font-bold leading-snug group-hover:text-primary transition-colors">{g.title}</h2>
              <p className="mt-2 text-sm text-muted-foreground leading-relaxed flex-1">{g.excerpt}</p>
              <span className="mt-4 inline-flex items-center gap-2 text-xs text-muted-foreground">
                <Clock className="w-3.5 h-3.5" /> {g.readTime}
                <ArrowRight className="w-4 h-4 ml-auto text-primary group-hover:translate-x-1 transition-transform" />
              </span>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
}
